import Firebase from "../firebase"

Firebase.initialize()
